<template>
  <div>
    <!-- 面包屑组件 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item>教务中心</el-breadcrumb-item>
      <el-breadcrumb-item>学管点名</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="24">
        <el-col :span="4">
          <el-date-picker @change="getTimeStr(classRecordPageParamVO.timeList)"
                          value-format="yyyy-MM-dd"
                          v-model="classRecordPageParamVO.classDate"
                          type="date"
                          placeholder="选择日期">
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <el-time-picker
            value-format="HH:mm"
            format="HH:mm"
            is-range
            v-model="classRecordPageParamVO.timeList"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="请选择时间段">
          </el-time-picker>
        </el-col>
        <el-col :span="3">
          <el-select v-model="classRecordPageParamVO.classId" placeholder="班级选择" clearable>
            <el-option
              v-for="item in classList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-input
            v-model="classRecordPageParamVO.realnameOrPhone"
            @clear="loadData"
            placeholder="手机号/姓名"
            clearable
          >
          </el-input>
        </el-col>
        <el-col :span="10">
          <el-button @click="handleSearch" type="primary">搜索</el-button>
          <el-button @click="handleBatchSignIn('signIn')" type="success">批量点名</el-button>
          <el-button @click="handleBatchSignIn('absence')" type="danger">批量缺勤</el-button>
          <el-button @click="handleBatchSignIn('makeUpClasses')" type="info">批量补课</el-button>
        </el-col>
      </el-row>
      <el-table :data="dataList">
        <el-table-column  label="学员姓名" width="200" prop="studentRealnameSnapshot">
          <template slot-scope="scope">
            <span>{{scope.row.realname + '（' + scope.row.stuPhone + '）'}}</span>
          </template>
        </el-table-column>
        <el-table-column  label="班级名称" width="250" prop="className"></el-table-column>
        <el-table-column  label="上课教室" width="115" prop="classRoom"></el-table-column>
        <el-table-column  label="上课日期" width="175" prop="classDate"></el-table-column>
        <el-table-column  label="上课时间段" width="185" prop="beginTime">
          <template slot-scope="scope">
            <span>{{scope.row.beginTime + ' - ' + scope.row.endTime}}</span>
          </template>
        </el-table-column>
        <el-table-column  label="剩余次数/小时" width="120">
          <template slot-scope="scope">
            <span>{{scope.row.reminderTimes + '/' + scope.row.reminderHours}}</span>
          </template>
        </el-table-column>
        <!--        <el-table-column  label="点名学管师" width="120" prop="studentManagerNameSnapshot"></el-table-column>-->
        <el-table-column  label="状态" width="90">
          <template slot-scope="scope">
            <span v-if="(scope.row.isSign==null || scope.row.isSign == 0) && scope.row.isRemedialTeaching != 1">未点名</span>
            <span v-if="scope.row.isSign == 1">已点名</span>
            <span v-if="scope.row.isSign == 2 && (scope.row.isRemedialTeaching == null || scope.row.isRemedialTeaching == 0)">已缺勤</span>
            <span v-if="scope.row.isRemedialTeaching == 1">已补课</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="135">
          <template slot-scope="scope">
            <el-button v-if="(scope.row.isSign ==null || scope.row.isSign == 0) && scope.row.isRemedialTeaching != 1" @click="openSignInDialog(scope.row)" type="text" style="color:#13C2C2">点名</el-button>
            <el-button v-if="scope.row.isSign != 2 && scope.row.isSign != 1 && scope.row.isRemedialTeaching != 1" @click="handleSignIn(scope.row,2)" type="text" style="color:#F53F3F">缺勤</el-button>
            <el-button v-if="scope.row.isSign != 1 && (scope.row.isRemedialTeaching == null || scope.row.isRemedialTeaching == 0)" @click="openMakeUpDialog(scope.row)" type="text" style="color:#FF9F00">补课</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="classRecordPageParamVO.pageNo"
        :page-size="classRecordPageParamVO.pageSize"
        :total="total" background
        layout="prev, pager, next, jumper,total"
      ></el-pagination>
    </el-card>

    <!-- 单个学生签到确认弹窗 -->
    <el-dialog title="确认点名" :visible.sync="dialogVisibleSignIn" width="600px" :close-on-click-modal="false">
      <el-form :model="signInForm" label-width="120px" v-if="currentStudent">
        <el-form-item label="学员姓名">
          <span>{{ currentStudent.realname }}（{{ currentStudent.stuPhone }}）</span>
        </el-form-item>
        <el-form-item label="班级名称">
          <span>{{ currentStudent.className }}</span>
        </el-form-item>
        <el-form-item label="上课教室">
          <span>{{ currentStudent.classRoom }}</span>
        </el-form-item>
        <el-form-item label="上课日期">
          <span>{{ currentStudent.classDate }}</span>
        </el-form-item>
        <el-form-item label="上课时间段">
          <span>{{ currentStudent.beginTime }} - {{ currentStudent.endTime }}</span>
        </el-form-item>
        <el-form-item label="消课类型" required>
          <el-select v-model="signInForm.deductType" placeholder="请选择消课类型">
            <el-option label="按时" value="time"></el-option>
            <el-option label="按次" value="times"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消课数量" required>
          <el-input
            v-model.number="signInForm.deductValue"
            :placeholder="signInForm.deductType === 'time' ? '请输入时长（小时）' : '请输入次数'"
            type="number"
            min="1"
          >
            <template slot="suffix">
              {{ signInForm.deductType === 'time' ? '小时' : '次' }}
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleSignIn = false">取 消</el-button>
        <el-button type="primary" @click="confirmSingleSignIn">确 认</el-button>
      </div>
    </el-dialog>

    <!-- 单个学生补课确认弹窗 -->
    <el-dialog title="确认补课" :visible.sync="dialogVisibleMakeUpLessons" width="600px" :close-on-click-modal="false">
      <el-form :model="makeUpForm" label-width="120px" v-if="currentStudent">
        <el-form-item label="学员姓名">
          <span>{{ currentStudent.realname }}（{{ currentStudent.stuPhone }}）</span>
        </el-form-item>
        <el-form-item label="班级名称">
          <span>{{ currentStudent.className }}</span>
        </el-form-item>
        <el-form-item label="上课教室">
          <span>{{ currentStudent.classRoom }}</span>
        </el-form-item>
        <el-form-item label="上课日期">
          <span>{{ currentStudent.classDate }}</span>
        </el-form-item>
        <el-form-item label="上课时间段">
          <span>{{ currentStudent.beginTime }} - {{ currentStudent.endTime }}</span>
        </el-form-item>
        <el-form-item label="补课备注">
          <el-input v-model="makeUpForm.remark" placeholder="可不填"></el-input>
        </el-form-item>
        <el-form-item label="消课类型" required>
          <el-select v-model="makeUpForm.deductType" placeholder="请选择消课类型">
            <el-option label="按时" value="time"></el-option>
            <el-option label="按次" value="times"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="消课数量" required>
          <el-input
            v-model.number="makeUpForm.deductValue"
            :placeholder="makeUpForm.deductType === 'time' ? '请输入时长（小时）' : '请输入次数'"
            type="number"
            min="1"
          >
            <template slot="suffix">
              {{ makeUpForm.deductType === 'time' ? '小时' : '次' }}
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleMakeUpLessons = false">取 消</el-button>
        <el-button type="primary" @click="confirmSingleMakeUp">确 认</el-button>
      </div>
    </el-dialog>

    <!-- 批量点名弹窗 -->
    <el-dialog title="批量点名" :visible.sync="dialogVisibleConfirmBatchSignIn"
               @close="callBatchDialogClose" :close-on-click-modal="false">
      <el-form :model="confirmSignInForm">
        <el-form-item label="上课日期" label-width="150px">
          <el-date-picker
            @change="getWaitSingClassList()"
            value-format="yyyy-MM-dd"
            v-model="classRecordPageParamVO.classDate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="班级" label-width="150px">
          <el-select @change="getWaitSingTimeList()" v-model="classRecordPageParamVO.classId" placeholder="班级选择">
            <el-option
              v-for="item in signClassList"
              :key="item.id"
              :label="item.className"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间段" label-width="150px">
          <span ref="signTimeSpanRef">
            <span class="span-sign-time"
                  v-for="(item2,index2) in signTimeList"
                  :class="{ spanSignTimeChecked: currentActiveIndex === index2 }"
                  @click="setActiveIndex(index2),getWaitSingStudentList(item2)"
                  :key="'st'+index2">{{item2.beginTime}}-{{item2.endTime}}</span>
          </span>
        </el-form-item>
        <el-form-item label="学生列表" label-width="150px">
          <!-- 全选按钮 -->
          <div class="select-all-btn" v-if="signStudentList && signStudentList.length !== 0" @click="checkAllSignStudent()" :class="{ 'is-checked': checkAllSignStudentArr.length !==0 && checkAllSignStudentArr.length == curSignStuArr.length }" title="全部选中当前学生">
            全 选 / 重 置
          </div>

          <!-- 学生列表容器 -->
          <div class="student-list-container">
            <div v-for="(item1, index1) in signStudentList" :key="'ss'+index1" class="student-item">
              <!-- 可签到学生 -->
              <el-tag v-if="item1.flag == 0" @click="checkSignStudent(item1.id)" :class="{ 'student-checked': curSignStuArr.includes(item1.id) }" class="student-tag">
                {{ item1.realname }}
              </el-tag>
              <!-- 已签到学生 -->
              <el-tag v-else type="info" disable-transitions class="student-tag signed-tag">
                {{ item1.realname }}
              </el-tag>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="callBatchDialogClose">关 闭</el-button>
        <el-button type="primary" @click="confirmBatchSignIn(1)">确认点名</el-button>
      </div>
    </el-dialog>

    <!-- 批量缺勤弹窗 -->
    <el-dialog title="批量缺勤" :visible.sync="dialogVisibleConfirmBatchQQ"
               @close="callBatchDialogClose" :close-on-click-modal="false">
      <el-form :model="classRecordPageParamVO">
        <el-form-item label="原计划上课日期" label-width="150px">
          <el-date-picker
            @change="getWaitSingClassList()"
            value-format="yyyy-MM-dd"
            v-model="classRecordPageParamVO.classDate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="班级" label-width="150px">
          <el-select @change="getWaitSingTimeList()" v-model="classRecordPageParamVO.classId" placeholder="班级选择">
            <el-option
              v-for="item in signClassList"
              :key="item.id"
              :label="item.className"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间段" label-width="150px">
          <span ref="signTimeSpanRef">
            <span class="span-sign-time"
                  v-for="(item2,index2) in signTimeList"
                  :class="{ spanSignTimeChecked: currentActiveIndex === index2 }"
                  @click="setActiveIndex(index2),getWaitSingStudentList(item2)"
                  :key="'st'+index2">{{item2.beginTime}}-{{item2.endTime}}</span>
          </span>
        </el-form-item>
        <el-form-item label="学生列表" label-width="150px">
          <!-- 全选按钮 -->
          <div class="select-all-btn" v-if="signStudentList && signStudentList.length !== 0" @click="checkAllSignStudent()" :class="{ 'is-checked': checkAllSignStudentArr.length !==0 && checkAllSignStudentArr.length == curSignStuArr.length }" title="全部选中当前学生">
            全 选 / 重 置
          </div>

          <!-- 学生列表容器 -->
          <div class="student-list-container">
            <div v-for="(item1, index1) in signStudentList" :key="'ss'+index1" class="student-item">
              <el-tag v-if="item1.flag == 0" @click="checkSignStudent(item1.id)" :class="{ 'student-checked': curSignStuArr.includes(item1.id) }" class="student-tag">
                {{ item1.realname }}
              </el-tag>
              <el-tag v-else type="info" disable-transitions class="student-tag signed-tag">
                {{ item1.realname }}
              </el-tag>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="callBatchDialogClose">关 闭</el-button>
        <el-button type="primary" @click="confirmBatchSignIn(2)">确认缺勤</el-button>
      </div>
    </el-dialog>

    <!-- 批量补课弹窗 -->
    <el-dialog title="批量补课" :visible.sync="dialogVisibleConfirmBatchBK"
               @close="callBatchDialogClose" :close-on-click-modal="false">
      <el-form :model="classRecordPageParamVO">
        <el-form-item label="补课备注" label-width="150px">
          <el-input v-model="classRecordPageParamVO.remark" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="原计划上课日期" label-width="150px">
          <el-date-picker
            @change="getWaitSingClassList()"
            value-format="yyyy-MM-dd"
            v-model="classRecordPageParamVO.classDate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="班级" label-width="150px">
          <el-select @change="getWaitSingTimeList()" v-model="classRecordPageParamVO.classId" placeholder="班级选择">
            <el-option
              v-for="item in signClassList"
              :key="item.id"
              :label="item.className"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间段" label-width="150px">
          <span ref="signTimeSpanRef">
            <span class="span-sign-time"
                  v-for="(item2,index2) in signTimeList"
                  :class="{ spanSignTimeChecked: currentActiveIndex === index2 }"
                  @click="setActiveIndex(index2),getWaitSingStudentList(item2)"
                  :key="'st'+index2">{{item2.beginTime}}-{{item2.endTime}}</span>
          </span>
        </el-form-item>
        <el-form-item label="学生列表" label-width="150px">
          <!-- 全选按钮 -->
          <div class="select-all-btn" v-if="signStudentList && signStudentList.length !== 0" @click="checkAllSignStudent()" :class="{ 'is-checked': checkAllSignStudentArr.length !==0 && checkAllSignStudentArr.length == curSignStuArr.length }" title="全部选中当前学生">
            全 选 / 重 置
          </div>
          <!-- 学生列表容器 -->
          <div class="student-list-container">
            <div v-for="(item1, index1) in signStudentList" :key="'ss'+index1" class="student-item">
              <el-tag v-if="item1.flag == 0" @click="checkSignStudent(item1.id)" :class="{ 'student-checked': curSignStuArr.includes(item1.id) }" class="student-tag">
                {{ item1.realname }}
              </el-tag>
              <el-tag v-else type="info" disable-transitions class="student-tag signed-tag">
                {{ item1.realname }}
              </el-tag>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="callBatchDialogClose">关 闭</el-button>
        <el-button type="primary" @click="confirmBatchSignIn">确认补课</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { formatDate } from "../../../plugins/date.js";
  export default {
    data() {
      return {
        activeName:'first',
        // 签到点名勾选
        multipleSelectionSignin:[],
        // 反向签到
        multipleSelectionReverseSignin:[],
        // 老师列表
        teacherList:[
          {
            value:'1',
            label:'全部老师',
          }
        ],
        // 班级列表
        classList:[],
        signClassList:[],
        studentNum:0,//点名人数
        absenceNum:0,//缺勤人数
        //用于获取数据列表
        classRecordPageParamVO: {
          classDate: '',
          classId:'',
          realnameOrPhone:'',
          timeList:['00:00:00','23:59:59'],
          timeStr:'',
          pageSize: 10,
          pageNo: 1,
          studentId: []
        },
        reverseSignInData: {
          classDate: null,
          classId:'',
          reverseSignDate:null,//反向签到日期
          pageSize: 10,
          pageNo: 1,
        },
        reverseSignInAbsenceNum:'',
        reverseSignInReverseSignNum:'',
        dataList: [],
        total: 0,
        // 当前操作的学生信息
        currentStudent: null,
        // 单个签到表单
        signInForm: {
          deductType: 'time', // 默认消课类型：按时
          deductValue: 1     // 默认时长（1小时，可根据实际需求调整）
        },
        // 单个补课表单
        makeUpForm: {
          remark: '',
          deductType: 'time', // 默认消课类型：按时
          deductValue: 1     // 默认时长（1小时，可根据实际需求调整）
        },
        // 添加学员查询参数
        addStudentForm:{
          name:''
        },
        // 确定添加学员弹窗参数
        confirmSignInForm:{
          name:'',
        },
        // 弹窗控制
        dialogVisibleConfirmBatchSignIn:false,
        dialogVisibleConfirmBatchQQ:false,
        dialogVisibleConfirmBatchBK:false,
        dialogVisibleSignIn: false, // 单个签到弹窗
        dialogVisibleMakeUpLessons: false, // 单个补课弹窗
        signStudentList: [],
        signTimeList: [],
        dialogVisibleConfirmReverseSignIn:false,
        currentActiveIndex: null,
        curSignStuArr: [],
        checkAllSignStudentArr: [],
      };
    },
    created() {
      this.loadData();
      this.getClassList();
    },
    filters: {
      formatDate(time) {
        var date = new Date(time);
        return formatDate(date, "yyyy-MM-dd");
      },
    },
    methods: {
      // 数据加载
      async loadData() {
        const { data: res } = await this.$http.post("/ea/student/classRecord/list",this.classRecordPageParamVO);
        if (res.code !== 200) return this.$message.error(res.message);
        this.dataList = res.result.records;
        this.total = res.result.total;
      },
      getTimeStr(tiemList){
        this.classRecordPageParamVO.timeStr = tiemList.join(',');
      },
      // 打开单个签到弹窗
      openSignInDialog(row) {
        this.currentStudent = row;
        // 从接口数据直接赋值默认值
        this.signInForm = {
          deductType: row.deductType == 1 ? 'times' : 'time', // 1=按次，其他=按时
          deductValue: row.deductTimes || 1 // 默认接口的deductTimes
        };
        this.dialogVisibleSignIn = true;
      },
      // 确认单个签到
      async confirmSingleSignIn() {
        if (!this.currentStudent) return;

        // 验证必填项
        if (!this.signInForm.deductType || !this.signInForm.deductValue) {
          return this.$message.warning('请完善消课类型和数量信息');
        }

        let data = {
          ...this.currentStudent,
          type: 1,
          deductType: this.signInForm.deductType,
          deductValue: this.signInForm.deductValue,
          useAmount: this.signInForm.deductValue // 传递消课数量到后端
        };

        try {
          await this.call(data);
          this.dialogVisibleSignIn = false;
          this.currentStudent = null;
        } catch (error) {
          this.$message.error('点名失败，请重试');
        }
      },
      // 打开单个补课弹窗
      openMakeUpDialog(row) {
        this.currentStudent = row;
        // 从接口数据直接赋值默认值
        this.makeUpForm = {
          remark: '',
          deductType: row.deductType == 1 ? 'times' : 'time',
          deductValue: row.deductTimes || 1
        };
        this.dialogVisibleMakeUpLessons = true;
      },
      // 确认单个补课
      async confirmSingleMakeUp() {
        if (!this.currentStudent) return;

        // 验证必填项
        if (!this.makeUpForm.deductType || !this.makeUpForm.deductValue) {
          return this.$message.warning('请完善消课类型和数量信息');
        }

        this.classRecordMakeUpVO = {
          studentId: this.currentStudent.studentId,
          scheduleTimePeriodId: this.currentStudent.scheduleTimePeriodId,
          classDate: this.currentStudent.classDate,
          type: 3,
          remark: this.makeUpForm.remark,
          deductType: this.makeUpForm.deductType,
          deductValue: this.makeUpForm.deductValue,
          useAmount: this.makeUpForm.deductValue
        };

        try {
          await this.makeUp();
          this.dialogVisibleMakeUpLessons = false;
          this.currentStudent = null;
        } catch (error) {
          this.$message.error('补课失败，请重试');
        }
      },
      // 各状态下的操作（保留原缺勤逻辑）
      handleSignIn(row,type){
        let data = row;
        if(type==2){
          this.$confirm('是否缺勤?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            data.type = 2;
            this.call(data);
          }).catch();
        }
      },
      // 套装页码切换
      handleCurrentChange(pageNo) {
        this.classRecordPageParamVO.pageNo = pageNo;
        this.loadData();
      },
      handleSizeChange(pageSize){
        this.classRecordPageParamVO.pageSize = pageSize;
        this.loadData();
      },
      // 批量点名
      handleBatchSignIn(type){
        this.classRecordPageParamVO = {
          classDate: '',
          classId:'',
          realnameOrPhone:'',
          timeList:['00:00:00','23:59:59'],
          timeStr:'',
          pageSize: 10,
          pageNo: 1,
          studentId: this.multipleSelectionSignin
        };
        if(type=='signIn'){
          this.dialogVisibleConfirmBatchSignIn = true;
        }else if(type=='absence'){
          this.dialogVisibleConfirmBatchQQ = true;
        }else{
          this.dialogVisibleConfirmBatchBK = true;
        }
      },
      // 点名获取班级
      async getWaitSingClassList() {
        if(this.classRecordPageParamVO.classDate){
          this.signClassList = [];
          this.classRecordPageParamVO.classId = "";
          this.signTimeList = [];
          this.signStudentList = [];
          const { data: res } = await this.$http.post("/ea/student/classRecord/getWaitSingClassList", this.classRecordPageParamVO);
          if (res.code !== 200) return this.$message.error(res.message);
          this.signClassList = res.result;
        }
      },
      callBatchDialogClose() {
        this.signClassList = [];
        this.classRecordPageParamVO.classId = "";
        this.signTimeList = [];
        this.signStudentList = [];
        this.dialogVisibleConfirmBatchSignIn = false;
        this.dialogVisibleConfirmBatchQQ = false;
        this.dialogVisibleConfirmBatchBK = false;
      },
      // 点名获取时间段
      async getWaitSingTimeList() {
        if(this.classRecordPageParamVO.classId && this.classRecordPageParamVO.classDate){
          this.signTimeList = [];
          this.signStudentList = [];
          const { data: res } = await this.$http.post("/ea/student/classRecord/getWaitSingTimeList", this.classRecordPageParamVO);
          if (res.code !== 200) return this.$message.error(res.message);
          this.signTimeList = res.result;
        }
      },
      setActiveIndex(index) {
        this.currentActiveIndex = index;
      },
      checkAllSignStudent(){
        let that = this
        that.checkAllSignStudentArr = []
        if(this.curSignStuArr.length != this.signStudentList.length){
          that.curSignStuArr = []
          this.signStudentList.forEach((item)=>{
            that.checkAllSignStudentArr.push(item.id)
            that.curSignStuArr.push(item.id)
          })
        }else{
          that.curSignStuArr = []
        }
      },
      checkSignStudent(studentId) {
        if(this.curSignStuArr.includes(studentId)){
          this.curSignStuArr.forEach((item,index) => {
            if(studentId == item){
              this.curSignStuArr.splice(index, 1)
            }
          })
        }else{
          this.curSignStuArr.push(studentId)
        }
      },
      // 点名获取学生
      async getWaitSingStudentList(item) {
        if(this.classRecordPageParamVO.classId){
          this.signStudentList = [];
          this.classRecordPageParamVO.scheduleTimePeriodId = item.scheduleTimePeriodId;
          const { data: res } = await this.$http.post("/ea/student/classRecord/getSignStudentList", this.classRecordPageParamVO);
          if (res.code !== 200) return this.$message.error(res.message);
          this.signStudentList = res.result;
        }
      },
      // 点名/缺勤接口调用
      async call(row) {
        let idModel = {
          'studentId': row.studentId,
          'useAmount': row.useAmount || 1, // 传递消课数量
          'classDate': row.classDate,
          'scheduleTimePeriodId': row.scheduleTimePeriodId,
          'type': row.type,
          'deductType': row.deductType, // 新增消课类型
          'deductValue': row.deductValue // 新增消课数量
        }
        const { data: res } = await this.$http.post("/ea/student/classRecord/call",idModel);
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message({
          message: res.message,
          type: 'success'
        });
        this.loadData();
      },
      // 补课接口调用
      async makeUp() {
        const { data: res } = await this.$http.post("/ea/student/classRecord/call",this.classRecordMakeUpVO);
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message({
          message: res.message,
          type: 'success'
        });
        this.loadData();
      },
      // 批量操作接口调用
      async callBatch(type) {
        let vo = {
          classId: this.classRecordPageParamVO.classId,
          classDate: this.classRecordPageParamVO.classDate,
          scheduleTimePeriodId: this.classRecordPageParamVO.scheduleTimePeriodId,
          type: type,
          studentIds: this.curSignStuArr.join(","),
          deductType: 'time', // 批量操作默认消课类型
          deductValue: 1     // 批量操作默认消课数量
        }
        const { data: res } = await this.$http.post("/ea/student/classRecord/callBatch", vo);
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message({
          message: res.message,
          type: 'success'
        });
        let item = {scheduleTimePeriodId: vo.scheduleTimePeriodId}
        await this.getWaitSingStudentList(item)
        await this.loadData();
      },
      // 反向签到获取人数
      async getAbsenceNum() {
        if(!this.reverseSignInData.reverseSignDate){
          this.$message({
            message: '请选择日期',
            type: 'warning'
          });
          return false;
        }
        const { data: res } = await this.$http.post("/ea/student/classRecord/absenceBatch",this.reverseSignInData);
        if (res.code !== 200) return this.$message.error(res.message);
      },
      // 签到点名勾选
      handleSelectionChangeSignin(val){
        this.multipleSelectionSignin = [];
        let list  = val;
        list.map(e=>{
          this.multipleSelectionSignin.push(e.id);
        })
      },
      // 获取所有班级
      async getClassList() {
        const { data: res } = await this.$http.get(`/ea/student/classRecord/classList`);
        if (res.code !== 200)
          return this.$message.error(res.message);
        let allList = res.result.classList;
        allList.forEach(e => {
          let item = {
            value:e.id,
            label:e.className
          }
          this.classList.push(item);
        });
      },
      // 反向签到点名勾选
      handleSelectionChangeReverseSignin(val){
        this.multipleSelectionReverseSignin = [];
        let list  = val;
        list.map(e=>{
          this.multipleSelectionReverseSignin.push(e.id);
        })
      },
      // 选择点名模式tab切换
      handleClick(tab, event) {
        this.loadData();
      },
      // 搜索
      handleSearch(){
        this.classRecordPageParamVO.pageSize = 10;
        this.classRecordPageParamVO.pageNo = 1;
        this.loadData();
      },
      handleClear(){
        this.classRecordPageParamVO.classDate = '';
        this.classRecordPageParamVO.classId = '';
        this.classRecordPageParamVO.realnameOrPhone = '';
        this.classRecordPageParamVO.timeList = ['00:00:00','23:59:59'];
        this.classRecordPageParamVO.timeStr = '';
        this.classRecordPageParamVO.pageSize = 10;
        this.classRecordPageParamVO.pageNo = 1;
      },
      // 确定批量点名
      confirmBatchSignIn(type){
        this.$confirm('确认提交选中的学生吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.callBatch(type);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '系统错误，已取消批量点名。非常抱歉，请在列表尝试单个点名或联系管理员！'
          });
        });
      },
    },
  };
</script>

<style lang="less" scoped>
  .el-pagination__total{
    float: right;
  }
  .span-sign-time{
    padding: 5px;
    background-color: whitesmoke;
    border-radius: 3px;
    font-size: 16px;
    margin-left: 8px;
    cursor: pointer;
  }
  .spanSignTimeChecked{
    background-color: dimgrey;
    color: white;
  }
  .student-list-container {
    display: flex;
    flex-wrap: wrap; /* 允许换行 */
    gap: 12px; /* 设置格子之间的间距 */
    margin-top: 2px;
  }

  .student-item {
    display: inline-flex; /* 防止布局被拉伸 */
  }

  .student-tag {
    font-size: 15px;
    color: black;
    cursor: pointer; /* 表明可点击 */
    transition: all 0.3s ease; /* 添加过渡效果 */
  }

  .select-all-btn {
    /* 全选按钮样式 */
    display: inline-block;
    cursor: pointer;
    padding: 1px 6px;
    margin-bottom: 10px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    font-size: 14px;
    color: #606266;
  }
  .select-all-btn.is-checked {
    /* 全选按钮选中状态 */
    color: #409EFF;
    border-color: #409EFF;
  }
  .student-checked {
    /* 单个学生选中状态 */
    background-color: #409EFF;
    color: white;
  }
  .signed-tag {
    /* 已签到学生样式 */
    cursor: not-allowed; /* 不可点击的指针 */
    opacity: 0.7; /* 降低透明度以示区别 */
  }
</style>
